import type { Block, Fragment, Inline, Text, Value } from '@gitbook/slate';

import { findDOMClosest } from './dom-closest';

/**
 * Find a Slate node from a DOM `element`.
 */
export default function findNode(
    element: HTMLElement,
    value: Value
): Text | Block | Inline | Fragment | null {
    const closest = findDOMClosest(element, '[data-key]');
    if (!closest) {
        return null;
    }

    const key = closest.getAttribute('data-key');
    if (!key) {
        return null;
    }

    const node = value.document.getNode(key);

    // @ts-expect-error
    return node || null;
}
